// Generates a beautiful, email-safe HTML signature from structured data.
const ACCENT = "#3B82F6";

function esc(s) {
  return String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

function icon(inner) {
  return `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="${ACCENT}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;display:block;">${inner}</svg>`;
}
const ICONS = {
  mail: icon('<rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 5L2 7"/>'),
  phone: icon('<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>'),
  globe: icon('<circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>'),
  pin: icon('<path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/>'),
  clock: icon('<circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>'),
};

function socialIcon(href, paths) {
  return `<a href="${esc(href)}" style="text-decoration:none;margin-right:8px;display:inline-block;"><svg width="18" height="18" viewBox="0 0 24 24" fill="${ACCENT}" style="vertical-align:middle;">${paths}</svg></a>`;
}
const SOCIAL = {
  linkedin: '<path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14zM8.34 17V9.99H6.01V17h2.33zM7.18 8.96c.75 0 1.36-.61 1.36-1.36 0-.75-.61-1.36-1.36-1.36-.76 0-1.37.61-1.37 1.36 0 .75.61 1.36 1.37 1.36zM18 17v-3.84c0-2.05-.44-3.63-2.84-3.63-1.15 0-1.92.63-2.24 1.23h-.03V9.99H10.7V17h2.33v-3.47c0-.92.17-1.8 1.31-1.8 1.12 0 1.13 1.05 1.13 1.86V17H18z"/>',
  instagram: '<path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.43.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.43.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.43-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.43-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16zm0 3.68A6.16 6.16 0 1 0 18.16 12 6.16 6.16 0 0 0 12 5.84zm0 10.16A4 4 0 1 1 16 12a4 4 0 0 1-4 4zm6.4-10.4a1.44 1.44 0 1 1-1.44-1.44 1.44 1.44 0 0 1 1.44 1.44z"/>',
  facebook: '<path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12z"/>',
  x: '<path d="M18.24 2.25h3.31l-7.23 8.26L22.5 21.75h-6.66l-5.21-6.82-5.97 6.82H1.34l7.73-8.84L1.5 2.25h6.83l4.71 6.23 5.2-6.23zm-1.16 17.52h1.83L7.01 4.13H5.04l12.04 15.64z"/>',
};

export function buildSignatureHtml(user = {}, company = {}) {
  const name = esc(user.name);
  const title = esc(company.sig_title || user.title);
  const email = esc(company.sig_email || user.email);
  const phone = esc(company.sig_phone || user.phone);
  const avatar = user.avatar_url;
  const cName = esc(company.name);
  const logo = company.logo_url;
  const website = esc(company.website);
  const cPhone = esc(company.phone);
  const address = esc(company.address);
  const banner = company.banner_url;
  const hours = esc(company.hours);
  const legal = esc(company.legal_text);

  const row = (ic, inner) => `<table cellpadding="0" cellspacing="0" style="border-collapse:collapse;margin:5px 0;"><tr><td style="vertical-align:middle;padding-right:8px;line-height:0;">${ic}</td><td style="vertical-align:middle;font-size:14px;color:#475569;line-height:20px;white-space:nowrap;">${inner}</td></tr></table>`;
  const rows = [];
  if (email) rows.push(row(ICONS.mail, `<a href="mailto:${email}" style="color:#475569;text-decoration:none;">${email}</a>`));
  const tel = phone || cPhone;
  if (tel) rows.push(row(ICONS.phone, `<a href="tel:${tel.replace(/\s/g, "")}" style="color:#475569;text-decoration:none;">${tel}</a>`));
  if (website) {
    const href = website.startsWith("http") ? website : `https://${website}`;
    rows.push(row(ICONS.globe, `<a href="${esc(href)}" style="color:#475569;text-decoration:none;">${website}</a>`));
  }
  if (address) rows.push(row(ICONS.pin, `<span style="color:#475569;">${address}</span>`));
  if (hours) rows.push(row(ICONS.clock, `<span style="color:#475569;">${hours}</span>`));

  // Social icons row
  const socials = [];
  const sl = (key, val) => { if (val) { const h = String(val).startsWith("http") ? val : `https://${val}`; socials.push(socialIcon(h, SOCIAL[key])); } };
  sl("linkedin", company.social_linkedin);
  sl("instagram", company.social_instagram);
  sl("facebook", company.social_facebook);
  sl("x", company.social_x);
  const socialRow = socials.length ? `<div style="margin-top:8px;">${socials.join("")}</div>` : "";

  const leftInner = logo
    ? `<img src="${esc(logo)}" width="84" style="display:block;max-width:84px;height:auto;" alt="${cName}"/>`
    : (cName ? `<div style="font-size:14px;font-weight:bold;color:${ACCENT};max-width:96px;">${cName}</div>` : "");
  const leftCell = leftInner
    ? `<td style="vertical-align:middle;padding-right:18px;border-right:3px solid ${ACCENT};">${leftInner}</td>`
    : "";

  const avatarBlock = avatar
    ? `<img src="${esc(avatar)}" width="52" height="52" style="border-radius:50%;object-fit:cover;display:block;border:2px solid ${ACCENT};margin-bottom:6px;" alt=""/>`
    : "";

  const bannerBlock = banner
    ? `<img src="${esc(banner)}" style="display:block;max-width:480px;width:100%;height:auto;border-radius:8px;margin-top:14px;" alt=""/>`
    : "";
  const legalBlock = legal
    ? `<div style="margin-top:12px;font-size:10px;color:#71717a;line-height:14px;max-width:480px;">${legal}</div>`
    : "";

  return `<div class="fd-signature" data-fd-sig="1" style="display:inline-block;margin-top:18px;background:#ffffff;border:1px solid #e6e9ef;border-radius:14px;padding:18px 22px;font-family:Arial,Helvetica,sans-serif;box-shadow:0 1px 2px rgba(15,23,42,0.04);">
<table cellpadding="0" cellspacing="0" style="border-collapse:collapse;width:auto;"><tr>
${leftCell}
<td style="vertical-align:middle;min-width:380px;${leftCell ? "padding-left:18px;" : ""}">
${avatarBlock}
<div style="font-size:17px;font-weight:bold;color:#0f172a;line-height:1.2;">${name}</div>
${title ? `<div style="font-size:12px;color:${ACCENT};letter-spacing:0.5px;margin-bottom:7px;">${title}</div>` : '<div style="margin-bottom:6px;"></div>'}
${rows.join("")}
${socialRow}
</td>
</tr></table>
${bannerBlock}
${legalBlock}
</div>`;
}

export function hasSignatureData(user = {}, company = {}) {
  return !!(user.avatar_url || user.title || user.phone || company.sig_title || company.sig_phone || company.sig_email || company.logo_url || company.website || company.phone || company.address || company.banner_url || company.legal_text || company.hours || company.social_linkedin || company.social_instagram || company.social_facebook || company.social_x);
}
